import {
  ADMIN_DELETE_POST_FAILURE,
  ADMIN_DELETE_POST_REQUEST,
  ADMIN_DELETE_POST_SUCCESS,
  ADMIN_POST_FAILURE,
  ADMIN_POST_REQUEST,
  ADMIN_POST_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
} from "./admin.types";

const initialState = {
  loading: false,
  error: false,
  users: [],
  posts:[]
};

export const adminReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_USER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case GET_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        users: payload,
      };
    }
    case GET_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case DELETE_USER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case DELETE_USER_SUCCESS: {
      const id = payload._id;
      const filteredPost = state.data.map((post) => post._id !== id);
      return {
        ...state,
        loading: false,
        error: false,
        users: filteredPost,
      };
    }
    case DELETE_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case ADMIN_POST_REQUEST: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case ADMIN_POST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        posts: payload,
      };
    }
    case ADMIN_POST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case ADMIN_DELETE_POST_REQUEST: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case ADMIN_DELETE_POST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        posts: payload,
      };
    }
    case ADMIN_DELETE_POST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    default: {
      return state;
    }
  }
};
